<!--预约到店-->
<template>
  <article>
    <div ref="header" class="tab-service">
      <ul class="tab-service-detail">
        <li v-show="clueFlow" :class="{'on':type==='clue'}" @click="onShiftTap('clue')"><a
            href="javascript:void(0);">线索</a></li>
        <li v-show="customerFlow" :class="{'on':type==='customer'}" @click="onShiftTap('customer')"><a
            href="javascript:void(0);">客户</a></li>
      </ul>
    </div>

    <scroller
      lock-x scrollbar-y
      use-pullup
      ref="myScroller"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
        <group v-show="clueFlow && type === 'clue'" v-for="(item,index) in clueList" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名：{{item.customer_name}}</p>
            <i slot="value" class="phone-icon-right" @click.stop="makeACall(item.mobile)"></i>
          </cell>
          <cell class="personal-info-detail" @click.native="clueArchives(item.id)">
            <div slot="after-title" class="title-list">
              <p v-for="(v,index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">下次致电：{{item.next_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
          </cell>
          <cell v-if="(authId === item.assignee_id && clueSingleOperatorAuth) || clueAllOperatorAuth" class="acard-btn">
            <x-button class="visitor-btn" slot="value" mini plain type="primary" @click="addClueRecord(item.id)">添加跟进记录
            </x-button>
          </cell>
        </group>

        <group v-show="customerFlow && type === 'customer'" v-for="(item,index) in customerList" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名：{{item.customer_name}}<span class="label">{{item.intention_level}}级</span></p>
            <i slot="value" class="phone-icon-right" @click="makeACall(item.mobile)"></i>
          </cell>
          <cell class="personal-info-detail personal-info-value" @click.native="customerArchives(item.id)">
            <div slot="after-title" class="title-list">
              <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <span slot="value" class="info info2">已到店{{item.store_visit_num}}次</span>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">下次致电：{{item.next_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
          </cell>
          <cell v-if="(authId === item.assignee_id && customerOperatorAuth)" class="acard-btn">
            <x-button class="visitor-btn" slot="value" mini plain type="primary" @click="addCustomerRecord(item.id)">
              添加跟进记录
            </x-button>
          </cell>
        </group>
        <p class="tip-text1">共有{{totalCount}}{{type === 'clue' ? '条线索' : '位客户'}}预约今日到店</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  XButton,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'
import authApi from '../../../common/auth'

export default {
  components: {
    Scroller,
    XButton,
    Cell,
    Group
  },
  data () {
    return {
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      type: 'clue',
      clueFlow: false,
      authId: '',
      authList: [],
      customerFlow: false,
      // 查看个人或全部线索权限
      clueAuth: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_view_all],
      // 查看个人或全部客户权限
      customerAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      // 操作权限(线索添加跟进记录)
      clueSingleOperatorAuth: false,
      clueAllOperatorAuth: false,
      // 操作权限(客户添加跟进记录)
      customerOperatorAuth: false,
      clueList: [],
      customerList: [],
      totalCount: 0,
      totalPage: 1,
      item_per_page: 20,
      page: 1,
      scrollerHeight: ''
    }
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.$store.state.promiseAuth.then(auth => {
      this.authList = auth.authList
      this.authId = auth.id
      let auth1 = authApi.haveSomeAuth(this.clueAuth, this.authList)
      let auth2 = authApi.haveSomeAuth(this.customerAuth, this.authList)
      if (auth1 || auth2) {
        // 满足客户查询要求
        this.customerFlow = this.customerAuth.some(t => {
          return this.authList.includes(t)
        })
        // 满足线索查询要求
        this.clueFlow = this.clueAuth.some(v => {
          return this.authList.includes(v)
        })
        this.clueSingleOperatorAuth = this.authList.includes(authApi.saleManage.sale_clue_follow_self)
        this.clueAllOperatorAuth = this.authList.includes(authApi.saleManage.sale_clue_follow_all)
        this.customerOperatorAuth = this.authList.includes(authApi.saleManage.sale_potential_customer_follow_up)
        if (this.clueFlow) {
          this.type = 'clue'
          this.getClueList()
        } else if (this.customerFlow) {
          this.type = 'customer'
          this.getCustomerList()
        }
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    getClueList () {
      this.$rest.saleManage.reservationClue({
        page: this.page,
        item_per_page: this.item_per_page
      }).then(res => {
        if (res.code === 0) {
          this.clueList = res.data.clues
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    getCustomerList () {
      this.$rest.saleManage.reservationCustomer({
        page: this.page,
        item_per_page: this.item_per_page
      }).then(res => {
        if (res.code === 0) {
          this.customerList = res.data.customers
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    onShiftTap (type) {
      if (this.type === type) return
      this.type = type
      this.page = 1
      if (this.type === 'clue') {
        this.customerList = []
        this.getClueList()
      } else if (this.type === 'customer') {
        this.clueList = []
        this.getCustomerList()
      }
    },
    makeACall (phone) {
      window.location.href = 'tel:' + phone
    },
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        if (this.type === 'clue') {
          this.$rest.saleManage.reservationClue({
            page: this.page,
            item_per_page: this.item_per_page
          }).then(res => {
            if (res.code === 0) {
              this.clueList.push(...res.data.clues)
              this.totalCount = res.data.total
              this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
              done(100)
            }
          })
        } else {
          this.$rest.saleManage.reservationCustomer({
            page: this.page,
            item_per_page: this.item_per_page
          }).then(res => {
            if (res.code === 0) {
              this.customerList.push(...res.data.customers)
              this.totalCount = res.data.total
              this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
              done(100)
            }
          })
        }
      } else {
        done()
      }
    },
    clueArchives (id) {
      if (id) {
        cache.clearSessionData('clueArchivesLocalData')
        this.$router.push({ path: '/salemanage/staff/cluearchives/', query: { id: id } })
      }
    },
    customerArchives (id) {
      if (id) {
        cache.clearSessionData('customerArchivesLocalData')
        this.$router.push({ path: '/salemanage/staff/customerarchives', query: { id: id } })
      }
    },
    addClueRecord (id) {
      if (id) {
        this.$router.push('/salemanage/staff/addcluerecord/' + id)
      }
    },
    addCustomerRecord (id) {
      if (id) {
        this.$router.push('/salemanage/staff/addcustomerrecord/' + id)
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
